import { RESET_ALL_PERSISTED_STATE } from '../../../constants/actions_type';

export const storeAllShipments = (state, action) => {
  console.log('Shipments payload:', action.payload);
  
  // Handle different possible data structures
  if (action.payload?.data?.data?.shipments) {
    state.allShipments = action.payload.data.data.shipments;
  } else if (action.payload?.data?.shipments) {
    state.allShipments = action.payload.data.shipments;
  } else if (action.payload?.shipments) {
    // Add this case to handle {shipments: Array(21)} structure
    state.allShipments = action.payload.shipments;
  } else if (action.payload?.allShipmentFromLocation) {
    state.allShipments = action.payload.allShipmentFromLocation;
  } else if (Array.isArray(action.payload)) {
    state.allShipments = action.payload;
  } else {
    console.error('Unexpected shipments data structure:', action.payload);
    // Keep existing data if we can't parse the new data
  }
};

export const cancelShipment = (state, action) => {
  state.allShipments = state.allShipments.filter(
    (shipment) => shipment.id !== action.payload.id
  );
};

export const resetAllStoredSHipments = (state, action) => {
  if (action.type === RESET_ALL_PERSISTED_STATE) { // Fixed comparison operator
    state.allShipments = []; // Fixed property name
  }
};
